import React, { Component } from "react";
import logo from "../../assets/images/Logo-Swip.svg";
import foto from "../../assets/images/foto.png";
import "./NavBar.css";

class NavBar extends Component {
  state = {
    isOpen: false
  };

  handleClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    return (
      <nav>
        <div className="header">
          <div className="foto">
            <img src={foto} className="foto" alt="foto" />
          </div>

          <div>
              <img src={logo} className="logo" alt="logo" />
          </div>

          <div className="btn" onClick={this.handleClick}>
            <div className="bar"> </div>
            <div className="bar1"> </div>
            <div className="bar"> </div>
          </div>
        </div>

        <ul className={this.state.isOpen ? "showNav" : "undefined"}>
          <br /> <br /> <br /> <br /> <br />
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/">Historial</a>
          </li>
          <li>
            <a href="/">Beneficios</a>
          </li>
          <li>
            <a href="/">Coach</a>
          </li>
          <li>
            <a href="/">Legal</a>
          </li>
          <li>
            <a href="/">FAQ´s</a>
          </li>
          <li>
            <a href="/">Soporte</a>
          </li>
          <li>
            <a href="/">Contacto</a>
          </li>
        </ul>
        <button className="cta">Menu</button>
      </nav>
    );
  }
}

export default NavBar;
